<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-toast></p-toast>
<router-outlet></router-outlet>
<app-error-modal #errorModal></app-error-modal>